/* src/app/common/components/side-bar/side-bar.component.scss */
:host {
  display: block;
  height: 100%;
}
.side-bar {
  border-right: 1px solid rgba(0, 0, 0, 0.07);
  height: 100%;
  position: relative;
  box-sizing: border-box;
  max-width: var(--side-menu-width);
  transition: width 0.3s cubic-bezier(0.5, 1, 0.89, 1);
}
.side-bar ion-item.expand-collapse {
  --inner-padding-end: 22px;
  --background: transparent;
  height: fit-content;
}
.side-bar ion-item.expand-collapse i {
  margin: 0;
  -webkit-transition: -webkit-transform 1s ease-in-out;
  -ms-transition: -ms-transform 1s ease-in-out;
  transition: transform 0.3s ease;
}
.side-bar.expanded {
  width: var(--side-menu-width);
}
.side-bar.collapsed {
  width: var(--side-menu-collapsed-width);
}
.side-bar.collapsed ion-item.expand-collapse i {
  transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}
::ng-deep ion-item[top] {
  position: sticky;
  top: 0;
  background: var(--ion-color-primary-tint);
  z-index: 10;
  --inner-padding-end: 22px;
}
::ng-deep ion-item[top] i {
  margin: 0;
  transition: transform 0.3s ease;
  color: #d6f4d6;
}
/*# sourceMappingURL=side-bar.component.css.map */
